import { computed } from '@vue/composition-api'

// hooks
import useEmployees from './useEmployees'

// utils
import { getFullNameFormat } from '@/utils'

export default function useEmployeesOp () {
  const { employees, getEmployees, loadingEmployees } = useEmployees()
  getEmployees()

  const employeesOp = computed(() => {
    return employees.value.map(employee => {
      return {
        value: employee.id,
        text: getFullNameFormat(employee),
        active: employee.is_active
      }
    })
  })

  return { employeesOp, employees, getEmployees, loadingEmployees }
}
